import {Component} from '@angular/core';

@Component({
  selector: 'overlay-loading',
  styleUrls: ['./overlay-loading.component.scss'],
  template: `<img alt="loading" src="assets/icon/logo_allya.gif">`
})
export class OverlayLoadingComponent {
}
